/**
 *
 * Asynchronously loads the component for ApplicantsV2
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
